import { render, staticRenderFns } from "./ColorReproductionReportDetail.vue?vue&type=template&id=4f414e2c&scoped=true"
import script from "./ColorReproductionReportDetail.vue?vue&type=script&lang=js"
export * from "./ColorReproductionReportDetail.vue?vue&type=script&lang=js"
import style0 from "./ColorReproductionReportDetail.vue?vue&type=style&index=0&id=4f414e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f414e2c",
  null
  
)

export default component.exports